import React, { Component } from "react";
import { Carousel } from "react-bootstrap";
import styled from "styled-components";

import heliosRifle from "../library/images/helios-rifle.jpg";
import killerwatt from "../library/images/killerwatt.jpg";

export class WeaponsCarousel extends Component {
  render() {
    return (
      <CarouselWrapper>
        <Carousel indicators={false} style={{ height: "100%", width: "100%" }}>
          <Carousel.Item>
            <img src={heliosRifle} alt="Helios Rifle" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={killerwatt} alt="Killerwatt" />
          </Carousel.Item>
        </Carousel>
      </CarouselWrapper>
    );
  }
}

const CarouselWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20vw 20px 20vw;

  img {
    height: 100%;
    width: 100%;
    border: solid;
    border-width: 2px;
    border-color: #dda7f5;
  }

  @media (max-width: 800px) {
    padding: 10px 10vw 20px 10vw;
  }

  @media (max-width: 650px) {
    padding: 10px 5vw 20px 5vw;
  }
`;

export default WeaponsCarousel;
